<iframe id="ketcher-frame"
  #ketcherIframe
  src="assets/ketcher/ketcher.html"
  scrolling="no"
  [width]="width"
  [height]="height">